var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showScrollArrow)?_c('div',{staticClass:"text-center",class:{ 'continue-down text-center': !_vm.toRight, 'd-inline-block icon-wrapper': _vm.toRight }},[_c('v-icon',{attrs:{"color":"error","large":""}},[_vm._v("mdi-arrow-down-bold-circle-outline")]),_c('div',{staticClass:"text-caption mt-n1"},[_vm._v("(scroll down)")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }